import SimpleArrowButton from '@components/bits/SimpleArrowButton';
import iub from '@utils/ImageUrlBuilder';
import Carousel from 'nuka-carousel';
import React, { FunctionComponent, useState } from 'react';

import styles from './index.module.scss';

type Props = {
  images?;
  motto;
  linkText;
};

const ImageGrid: FunctionComponent<Props> = (imageGrid) => {
  const [slideIndex, setSlideIndex] = useState(0);

  return (
    <div className={styles.root}>
      {imageGrid?.images?.length === 1 ? (
        <>
          <div
            style={{ backgroundImage: `url(${iub(imageGrid?.images[0].asset).url()})` }}
            title={`${imageGrid?.images[0].alt}`}
            className={styles.singleImg}
          />
          <p className={styles.caption}>{imageGrid?.images[0].caption}</p>
        </>
      ) : (
        <>
          <div className={styles.multImgWrapper}>
            {imageGrid?.images?.map((image, key) => (
              <div
                key={key}
                style={{ backgroundImage: `url(${iub(image).width(600).url()})` }}
                title={`${image.alt}`}
                className={styles.img}
              />
            ))}
          </div>
          <div className={styles.mobileSlider}>
            <div className={styles.pagination}>
              {slideIndex + 1} / {imageGrid?.images?.length}
            </div>

            <Carousel
              slideIndex={slideIndex}
              afterSlide={(slideIndex) => setSlideIndex(slideIndex)}
              wrapAround={true}
              renderBottomCenterControls={null}
              renderCenterLeftControls={null}
              renderCenterRightControls={null}>
              {imageGrid?.images?.map((image, key) => (
                <div key={key} className={styles.wrapper}>
                  <div
                    style={{ backgroundImage: `url(${iub(image).width(600).url()})` }}
                    title={`${image.alt}`}
                    className={styles.imgMobile}
                  />
                </div>
              ))}
            </Carousel>
          </div>
        </>
      )}

      {imageGrid?.motto && (
        <div className={styles.bottom}>
          <p>{imageGrid?.motto || ''}</p>
          {imageGrid?.linkText?.title && (
            <SimpleArrowButton classes={styles.button} cta={imageGrid?.linkText} />
          )}
        </div>
      )}
    </div>
  );
};

export default ImageGrid;
